import React, { useState } from 'react';
import './App.css';

const API_URL = 'http://localhost:3002';
const DEFAULT_MODELS = {
  groq: 'llama3-8b-8192',
  huggingface: 'mistralai/Mistral-7B-Instruct-v0.2',
};
const SOL_ADDRESS = '2zmewxtyL83t6WLkSPpQtdDiK5Nmd5KSn71HKC7TEGcU';
const SOLSCAN_API = `https://api.solscan.io/account/transactions?address=${SOL_ADDRESS}&limit=10`;
const MIN_SOL = 0.01;

function App() {
  const [message, setMessage] = useState('');
  const [chatHistory, setChatHistory] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedProvider, setSelectedProvider] = useState('groq');
  const [questionCount, setQuestionCount] = useState(0);
  const [verifying, setVerifying] = useState(false);
  const [verifyMsg, setVerifyMsg] = useState('');
  const QUESTION_LIMIT = 10;

  const handleSend = async () => {
    if (!message.trim() || questionCount >= QUESTION_LIMIT) return;

    const userMessage = message;
    setMessage('');
    setChatHistory(prev => [...prev, { role: 'user', content: userMessage }]);
    setLoading(true);
    setQuestionCount(prev => prev + 1);

    try {
      const response = await fetch(`${API_URL}/api/chat`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ 
          message: userMessage,
          provider: selectedProvider,
          model: DEFAULT_MODELS[selectedProvider]
        }),
      });
      const data = await response.json();
      setChatHistory(prev => [...prev, { role: 'assistant', content: data.response }]);
    } catch (error) {
      console.error('Error:', error);
      setChatHistory(prev => [...prev, { role: 'assistant', content: 'Sorry, there was an error processing your request.' }]);
    }

    setLoading(false);
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSend();
    }
  };

  const handlePay = () => {
    window.open(`https://solscan.io/account/${SOL_ADDRESS}`, '_blank');
  };

  const handleVerify = async () => {
    setVerifying(true);
    setVerifyMsg('결제 내역을 확인 중입니다...\nVerifying payment on Solana...');
    try {
      const res = await fetch(SOLSCAN_API);
      const data = await res.json();
      if (!Array.isArray(data)) throw new Error('No transaction data');
      // Find incoming tx >= 0.01 SOL
      const found = data.find(tx => {
        if (!tx.parsedInstruction) return false;
        return tx.parsedInstruction.some(instr =>
          instr.type === 'transfer' &&
          instr.info &&
          instr.info.destination === SOL_ADDRESS &&
          Number(instr.info.lamports || 0) / 1e9 >= MIN_SOL
        );
      });
      if (found) {
        setQuestionCount(0);
        setVerifyMsg('결제가 확인되었습니다!\nPayment verified! You can now continue chatting.');
      } else {
        setVerifyMsg('아직 결제가 확인되지 않았습니다.\nNo eligible payment found. Please try again after a few seconds.');
      }
    } catch (e) {
      setVerifyMsg('결제 확인 중 오류가 발생했습니다.\nError occurred during payment verification.');
    }
    setVerifying(false);
  };

  return (
    <div className="app">
      <header className="header">
        <img src="/solis-logo.png.png" alt="Solis AI Logo" className="solis-logo" />
        <div className="model-selector">
          <select 
            value={selectedProvider} 
            onChange={(e) => setSelectedProvider(e.target.value)}
            className="provider-select"
          >
            <option value="groq">Groq</option>
            <option value="huggingface">Hugging Face</option>
          </select>
        </div>
      </header>
      <div className="chat-container">
        {chatHistory.map((msg, index) => (
          <div key={index} className={`message ${msg.role}`}>
            <div className="message-content">
              {msg.role === 'assistant'
                ? msg.content.split(/\n{2,}|\r?\n/).map((para, i) => (
                    <p key={i} style={{margin: '0.7em 0'}}>{para}</p>
                  ))
                : msg.content}
            </div>
          </div>
        ))}
        {loading && <div className="loading">AI is thinking...</div>}
      </div>
      <div className="input-container">
        <textarea
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          onKeyPress={handleKeyPress}
          placeholder="Ask about Solana..."
          disabled={loading || questionCount >= QUESTION_LIMIT}
        />
        <button onClick={handleSend} disabled={loading || !message.trim() || questionCount >= QUESTION_LIMIT}>
          Send
        </button>
      </div>
      {questionCount >= QUESTION_LIMIT && (
        <div className="limit-message">
          <p>질문 제한(10회)에 도달했습니다.<br />
          더 사용하려면 0.01 SOL을 아래 주소로 전송해 주세요.<br />
          <span style={{fontSize:'0.95em',color:'#aaa'}}>You have reached the 10 question limit.<br />To continue, please send 0.01 SOL to the address below.</span></p>
          <div className="sol-address">{SOL_ADDRESS}</div>
          <button className="pay-btn" onClick={handlePay}>Solscan에서 결제하기<br />Pay on Solscan</button>
          <button className="pay-btn" style={{marginLeft: '1rem'}} onClick={handleVerify} disabled={verifying}>
            {verifying ? '확인 중...\nVerifying...' : '결제 확인\nVerify Payment'}
          </button>
          {verifyMsg && <div className="verify-msg">{verifyMsg.split('\n').map((line, i) => <div key={i}>{line}</div>)}</div>}
        </div>
      )}
    </div>
  );
}

export default App; 